import { getToolsClient } from '@/services/tools'
const toolsAxios = getToolsClient()
const baseEndpoint = '/device/import-set-to-customer'

export const constants = {
  data: {
    iconOptions: [],
  },
}

export const uploadFile = async (data) => {
  let response
  try {
    const res = await toolsAxios({
      method: 'PATCH',
      url: `${baseEndpoint}`,
      data: data,
    })
    response = res?.data
  } catch (error) {
    response = error.response
  }
  return response
}
